import GoogleMeetServices from "../../../services/GoogleMeetService";
import { getValidGoogleAccessToken } from "../Auth/GoogleMeetAuthHelper";

const GoogleProvider = {
  async getValidAccessToken() {
    return getValidGoogleAccessToken();
  },

  async createMeeting(payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Google Meet not authenticated");
    
    return GoogleMeetServices.createUserMeeting(payload);
  },

  async getUpcomingMeetings() {
    return GoogleMeetServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId) {
    return GoogleMeetServices.deleteMeeting(meetingId);
  },
  
  async deleteExpiredMeetings() {
    return GoogleMeetServices.deleteExpiredMeetings();
  },

  getName() {
    return "Google Meet";
  }
};

export default GoogleProvider;
